import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=18bf4b56&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18bf4b56')) {
      api.createRecord('18bf4b56', component.options)
    } else {
      api.reload('18bf4b56', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=18bf4b56&", function () {
      api.rerender('18bf4b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bbVom5RKRK9u/JS/comp/DateRangeExt.vue"
export default component.exports